import React, { useEffect } from "react";
import { connect } from "react-redux";

import { FaCalendarAlt } from "react-icons/fa";



const HolidayDetails = (props) => {

const { name, location, date } = props;

return (
    <div className="flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-green-50">
              <FaCalendarAlt className="text-green-600 text-lg" />
            </div>

            <div>
              <h3 className="font-semibold text-gray-800">{name}</h3>
              <div className="flex items-center text-gray-600 text-xs mt-1">
                🇵🇭 {location}
              </div>
            </div>
          </div>

          <span className="text-xs font-medium text-green-700 border border-green-300 bg-green-50 px-3 py-0.5 rounded-full">
            {date}
          </span>
        </div>
  );
};

const mapStateToProps = (state) => ({
	// recordList: state.trainingClass.trainingClassList?.items,
	// pagination: state.trainingClass.trainingClassList?.pagination,
	// filters: state.trainingClass.trainingClassList?.filters,
	// requesting: state.trainingClass.trainingClassList?.requesting,
	// error: state.trainingClass.trainingClassList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	// doSearch: (filters) => dispatch(getTrainingClassList(filters)),
	// doDelete: (id) => dispatch(doTrainingClassDelete(id)),
	// doRecordReset: () => dispatch(doTrainingClassReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HolidayDetails);
